<template>
  <div id="pageUploadPhones" class="d-flex">
    <MainBarMenuV2 v-if="user.core_role_id > 11 && user.core_role_id < 20"/>
    <MainBarMenu v-if="user.core_role_id < 12 && user.core_role_id > 0"/>
    <div class="header-top">
      <div class="container-fluid">
        <!-- Encabezado del usuario -->
        <HeadingUser />
        <!-- end -->
      </div>
    </div>
    <div class="layout-content container-fluid mt-5">


      <!-- Titulo -->
      <header-v2 :title="'Gestión de la Información'"/>
      <!-- end -->

      <!-- contenido -->
      <b-col cols="10" class="col-10 mx-auto" id="uploadPhones">
        <!-- contenido de la navegacion -->
        <nav-bar-v2
            :items="itemsNavBar">
            <template v-slot:nav-empleados>
              <b-col cols="11" class="my-5">
                <h4 class="text-formatting-v2">
                  <strong>Carga de teléfonos</strong> 
                </h4>

                <!-- mensaje informativo-->
                <p class="text-formatting-v2">
                  Selecciona un archivo <mark> Excel </mark> 
                  para poder hacer la carga masiva de números de contacto de empleados.
                <br>
                  No olvides cumplir los requerimientos necesarios para evitar posibles inconvenientes.
                </p>
                <!-- end -->

                <b-row>
                  <!-- cargar archivo -->
                  <b-col cols="12" sm="5">

                    <!-- alerta -->
                    <div class="alert alert-success d-flex align-items-center with-border-v2 success-v2">
                      <span class="icon icon-info text-success mr-4"></span>
                      <p class="text-formatting-v2 p-0 m-0">
                        Carga de archivo <strong>teléfonos</strong> de empleados.
                      </p>
                    </div>
                    <!--- end -->

                    <!-- form -->
                    <form id="file-upload-form" class="uploader">
                      <input 
                        id="phones" 
                        type="file"
                        @change="filesSelected"
                        accept=".csv" />

                      <label for="phones" id="file-drag" class="pointer">
                        <img 
                          id="file-image" 
                          src="@/assets/images/icons/ht_icon_upload.svg">
                        <div id="start">
                          <div class="text-formatting-v2">
                            <strong>
                              Arrastra aquí el archivo Excel (teléfonos de empleados)
                            </strong> 
                          </div>
                          <div class="text-formatting-v2">
                            CSV
                          </div>
                          <br>
                          <span id="phones-btn" class="button-v2 primary text-formatting-v2"> 
                            <strong>
                              Subir archivo
                            </strong>
                          </span>
                        </div>
                      </label>
                    </form>
                    <!-- end -->

                  </b-col>
                  <!-- end -->

                  <!-- alerta del archivo y soporte -->
                  <b-col cols="12" sm="7">

                    <!-- alerta -->
                    <div class="alert d-flex align-items-center with-border-v2 primary-v2">
                      <span class="icon icon-info text-primary mr-4"></span>
                      <p class="text-formatting-v2 p-0 m-0">
                        El sistema permite ingresar la información de manera manual o por medio de la carga de un archivo Excel.
                        <br>
                        <br>
                        Recuerda que si decides hacer la carga del <b>archivo Excel</b>, 
                        este debe contener tan solo dos columnas, 
                        <b>el número de identificación del empleado y su número de contacto.</b>
                        <br>
                        <br>
                        Para que puedas realizar el proceso de manera <b>manual</b> e individual, 
                        por favor dirígete a la <b>sección de resumen.</b>
                      </p>
                    </div>
                    <!--end -->

                    <!-- link de plantilla -->
                    <a 
                      class="text-formatting-v2 a-v2"
                      :href="serverPath + '/storage/docs_vp2/health_tracker/phones-health-tracker.csv'">
                      Descargar plantilla de contactos 
                      <span 
                        style="font-size:15px" 
                        class="icon icon icon-download3 mt-1 ml-1"> </span>
                    </a>
                  </b-col>
                  <!-- end -->
                </b-row>
              </b-col>
              <b-col cols="12" class="my-5">
                <table-phone ref="table"/>
              </b-col>
            </template>
        </nav-bar-v2>
        <!-- end -->
      </b-col>
      <!-- end -->

       <!-- modal de subida de archivo -->
      <modal-confirmation 
        modal-id="modal-upload"
        include-loader
        :processing="loading2"
        @click:accepted="saveFilesSelected">
          <template #body>
            <img class="col-4 my-3" src="@/assets/images/icons/ht_icon_upload_cloud_2_line.svg" />
            <p class="text-formatting-v2 h2-v2 text-center">
              <strong>
                Se cargarán un archivo de teléfonos 
              </strong>
            </p>
            <h3>{{fileName}}</h3>
            <p class="text-formatting-v2 text-center">
              Recuerda que este debe contener tan solo dos columnas,<b> 
              el numero de identificación del empleado y su numero de contacto.</b>
            </p>
          </template>
          <template #buttonText>
            <strong>
              Entendido
            </strong>
          </template>
      </modal-confirmation>
      <!-- end -->

      <!-- modal para todo ok -->
      <modal-confirmation 
        modal-id="modal-success"
        v-if="message.message"
        @click:accepted="$bvModal.hide('modal-success')">
          <template #body>
            <img 
              class="col-4 my-3" 
              src="@/assets/images/icons/ht_icon_checkbox_circle_line.svg" />
            <p class="text-formatting-v2 h2-v2 text-center">
              <strong>
                ¡Proceso exitoso!
              </strong> 
            </p>
            <p class="text-formatting-v2 text-center">
              {{ message.message }}
            </p>
          </template>
          <template #buttonText>
            <strong>
              Entendido
            </strong>
          </template>
      </modal-confirmation>
      <!-- end -->
      

      <!-- modal error -->
      <modal-confirmation 
        v-if="error.message"
        modal-id="modal-fail"
        @click:accepted="$bvModal.hide('modal-fail')">
          <template #body>
            <img 
              class="col-4 my-3" 
              src="@/assets/images/icons/ht_icon_close_circle_line.svg" />
            <p class="text-formatting-v2 h2-v2 text-center">
              <strong>
                ¡Proceso fallido!
              </strong> 
            </p>
              <p class="text-formatting-v2 text-center">
                {{ error.message }}
              </p>
          </template>
          <template #buttonText>
            <strong>
              Entendido
            </strong>
          </template>
      </modal-confirmation>
      <!-- end -->
    </div>
  </div>
  <!-- #page-onboarding -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import MainBarMenu from "@/components/layouts/MainBarMenu.vue";
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import TablePhone from "./tables/tablePhone.vue";
import serverConfig from "../../services/config";

export default {
  name: "HomeOnBoarding",
  components: {
    MainBarMenu,
    MainBarMenuV2,
    HeadingUser,
    TablePhone,
    NavBarV2: () => import('@/components/common/navs/NavBarV2.vue'),
    HeaderV2: () => import('../../components/common/header/HeaderV2.vue'),
    ModalConfirmation: () => import('../../components/common/modal/ModalConfirmation.vue')
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      fileName: ''
    };
  },
  created() {
    this.actUser();
  },
  beforeMount() {
  },

  computed: {
    ...mapState("modCore", [
      "user",
      ]),
      ...mapState("modOhAnalyst", [
        "loading",
        "loading2",
        "error",
        "message",
        "tablePhoto",
        "tablePhone",
        "responsiblePhoto",
        "responsiblePhone",
        "employeeInfo",
        "employeesBySearch"
      ]),
    itemsNavBar() {
      return [
        {
          name: 'Empleados',
          path: 'nav-empleados'
        }
      ]
    }
  },

  methods: {
    ...mapActions("modCore", ["actGetOnboarding", "actUser"]),
    ...mapActions("modOhAnalyst",["actUploadPhonesEmployees"]),

     filesSelected() {
            const dato = document.querySelector("#phones");
            this.fileName = dato.files[0].name;
            this.$root.$emit('bv::show::modal','modal-upload')
    },
    saveFilesSelected(){
        var formData = new FormData();
        const fileSelected = document.querySelector("#phones");
        formData.append("file", fileSelected.files[0]);
        this.actUploadPhonesEmployees(formData).then(() => {
                if(this.error.message){
                    this.$root.$emit('bv::hide::modal','modal-upload')
                    this.$root.$emit('bv::show::modal','modal-fail')
                    this.nameFile = ''
                }else{
                    this.$root.$emit('bv::hide::modal','modal-upload')
                    this.$root.$emit('bv::show::modal','modal-success')
                    this.nameFile = ''
                }
            let data = {
                    page: ''
            } 
            this.$refs.table.loadRowsPhone(data)
        })
    }
  },
};
</script>

<style lang="scss">
/** Carousel */
#uploadPhones {

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #1C3A4E;
    padding-left: 5%;
    text-align: justify;
  }

  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 150px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 }
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom {
    from{ bottom:-100px; opacity:0 }
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  font-family: Open Sans;
    .responsible{
        background-color: #EEF2FA;
    }
    h4{
        font-weight: 600;
        font-size: 16px;
    }
    .alert{
        color:black;
    }
    .icon{
        font-size: 20px;
    }
    .regular{
        padding: 5px 15px;
        font-size: 16px;
        border-radius: 100px;
        background-color: white;
        border: 2px solid #269887;
        color: #269887;
    }
    .btn-create{
        padding: 12px;
        border-radius: 20px;
        background-color: #269887;
        border: none;
        color: white;
        display: flex;
        align-items: center;
        transition: 0.5s;

        span {
            font-size: 30px;
            line-height: 0;
            margin: 0 5px;
            font-weight: 500;
        }
    }
    .btn-create:hover{
        background-color: #27a391;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
    }
    .check-status{
        .status{
        padding: 5px 10px;
        border-radius: 20px;
        font-size: 14px;
        }
    }
    .file-upload-img {
        height: 200px;
        border-radius: 15px;
        text-align: center;
        display: flex;
        align-items: center;
        border: 2px #0C9E42 dashed;
        margin-bottom: 15px;
        box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);

            input[type="file"] {
            opacity: 0;
            filter: alpha(opacity=0);
            display: block;
            position: absolute;
            cursor: pointer;
            z-index: 1;
            height: 150px;
            }

            span p{
                height: 150px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
    }
}
</style>